// /src/components/formbuilder/admin/utils/paletteConfig.js

// 🧩 Champs standards (simples)
export const formCategories = [
  {
    id: 'textFields',
    title: '📝 Champs de saisie',
    fields: [
      { type: 'text', title: 'Texte court' },
      { type: 'textarea', title: 'Zone de texte (multiligne)' },
      { type: 'email', title: 'Adresse e-mail' },
      { type: 'number', title: 'Nombre' },
      { type: 'tel', title: 'Téléphone' },
      { type: 'url', title: 'Lien / URL' },
    ],
  },
  {
    id: 'choiceFields',
    title: '🎛️ Choix / Sélection',
    fields: [
      { type: 'select', title: 'Liste déroulante' },
      { type: 'selectMultiple', title: 'Liste déroulante multiple' },
      { type: 'radio', title: 'Boutons radio' },
      { type: 'checkbox', title: 'Case à cocher' },
    ],
  },
  {
    id: 'fileDateFields',
    title: '📅 Fichiers & dates',
    fields: [
      { type: 'file', title: 'Fichier' },
      { type: 'date', title: 'Date' },
      { type: 'datetime', title: 'Date + heure' },
    ],
  },
];

// 📄 Blocs statiques
export const staticBlocks = [
  { type: 'staticTitle', title: 'Titre / Sous-titre' },
  { type: 'staticText', title: 'Bloc de texte' },
  { type: 'separator', title: 'Séparateur' },

];

// 🧠 Champs complexes / métiers
export const complexFields = [
  { type: 'person', title: 'Personne' },
  { type: 'address', title: 'Adresse' },
  { type: 'company', title: 'Entreprise' },
  { type: 'group', title: 'Groupe générique' },
  { type: 'groupChoice', title: 'Groupe à choix' },
];
/*
export const layoutBlocks = [
  {
    type: "layout2cols",
    title: "Bloc 2 colonnes"
  },
  {
    type: "layout3cols",
    title: "Bloc 3 colonnes"
  }
];
*/